import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "MedicationReminder"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V6C1.5 6.82843 2.17157 7.5 3 7.5V21C3 21.8284 3.67157 22.5 4.5 22.5H13.5C14.3284 22.5 15 21.8284 15 21V7.5C15.8284 7.5 16.5 6.82843 16.5 6V3C16.5 2.17157 15.8284 1.5 15 1.5ZM21 16.5C22.6569 16.5 24 15.1569 24 13.5C24 11.8431 22.6569 10.5 21 10.5C19.3431 10.5 18 11.8431 18 13.5C18 15.1569 19.3431 16.5 21 16.5ZM6.75 10.5H4.5V18H6.75V10.5ZM13.5 21H4.5V19.5H8.25V9H4.5V7.5H13.5V21ZM3 3V6H15V3H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/MedicationReminder.vue"]]);
